import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import UserLogout from './user-logout';
import { Divider, styled } from '@mui/material';

const CustomDivider = styled(Divider)({
    backgroundColor: 'gray', // 任意の色に変更
    height: '0.1px' // 任意の高さや太さに変更
  });
  
function GlobalMenu(props){
    const [menu, setMenu] = useState(props.menu)

    useEffect(()=>{
        setMenu(props.menu)
    },[props])

    const categoriesUrl = "/category"

    /**
     * トピック追加・編集ページのURLを生成する
     * @param  Number id カテゴリID
     */
    const topicsUrl = (id) =>{
        return `/topics/${id}`;
    }

    const liArray = menu.map((list) => {
        const id   = list.CATEGORY_ID;
        const name = list.CATEGORY_NAME;

        return (
            <li key={id}>
                <Link to={topicsUrl(id)}>{name}</Link>
            </li>
        );
    });

    return(
            <div id="global_menu">
                <div className="logo"></div>
                <div className="signage-manager">サイネージマネージャー</div>
                <UserLogout auth={props.auth} />
                <CustomDivider/>
                <div className="section"><Link to={categoriesUrl}>カテゴリ</Link></div>
                <div className="section"><Link to={"/snsauth"}>SNS連携設定</Link></div>
                <CustomDivider/>
                <div className="menu_list">
                    <ul>
                        {liArray}
                    </ul>
                </div>
                <CustomDivider/>
                <div className="setting_button"><Link to={"/settings"}>設定</Link></div>
                <CustomDivider/>
            </div>
    )
}

export default GlobalMenu

GlobalMenu.defaultProps = {
    menu: []
};
